





import { Component, Prop, Vue } from 'vue-property-decorator'

import { sanitizeRichText } from '@/utils/richText'

@Component
export default class RichTextContent extends Vue {
  @Prop({ type: String, default: null })
  html!: string | null

  get safeHtml() {
    return sanitizeRichText(this.html)
  }
}
